// @author: Insocder HG

// here we will get all products from the membership page, and then we will randomize the products
// and then we will redirect to the product page
// Remark: we have used one of the membership product dropdown to get all links dynamically, if admin disable/draft the product, this script will not work

let dataProducts = [];
fetch('/products/whiskers-n-paws-paws-for-good-membership-monthly-hong-kong-dog-rescue-donation')
  .then(response => response.text())
  .then(data => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(data, 'text/html');
    let options = doc.querySelectorAll('.membership_beneficiary_group select option');
    options.forEach(option => {
      dataProducts.push(option.getAttribute('data-product'));
    });


    // Select all elements with the data-random attribute
    var randomElements = document.querySelectorAll('[data-random]');

    // Iterate over the selected elements
    if (randomElements.length === 0) {
        return;
    }
    randomElements.forEach(function(randomElement) {
        // Add a click event listener
        randomElement.addEventListener('click', function(e) {
            // Prevent the default action
            e.preventDefault();

            // Generate a random index
            var randomIndex = Math.floor(Math.random() * dataProducts.length);

            // Get a random product
            var randomProduct = dataProducts[randomIndex];

            // Redirect to the product page
            window.location.href = randomProduct;
        });
    });


  });